<div class="container-fluid px-0 px-xl-5 py-4 py-xl-5">
	<div class="container-xl px-xl-0 ml-0">
		<div
			class="d-flex flex-wrap justify-content-between align-items-center"
		>
			<h2 class="mb-4">
				{{ 'thematique_formation-list-title' | translate }}
			</h2>
			<!-- Mode display list-->
			<div class="d-none d-lg-block mb-4 mode-display-container">
				<nz-radio-group [(ngModel)]="mode">
					<label nz-radio-button nzValue="card"
						><i nz-icon nzType="appstore" nzTheme="outline"></i
					></label>
					<label nz-radio-button nzValue="inline"
						><i nz-icon nzType="bars" nzTheme="outline"></i
					></label>
				</nz-radio-group>
			</div>
			<!-- /Mode display list-->
			<!-- Sort and Filter -->
			<div
				class="d-flex justify-content-start align-items-center sort-container mb-4"
				*ngIf="searchParams; else loadingTpl"
			>
				<nz-select
					[(ngModel)]="selectedSort"
					[nzPlaceHolder]="'sort_select-placeholder' | translate"
					style="width: 250px; margin-right: 15px"
					(ngModelChange)="handleSortChange()"
				>
					<nz-option
						*ngFor="let option of sortOptions"
						[nzValue]="option.sort + '_' + option.order"
						[nzLabel]="option.label | translate"
					>
					</nz-option>
				</nz-select>
				<hpf-formation-select
					[(id)]="searchParams.props.formation"
					[nullable]="false"
					[emptyLabel]="'common_filter-empty' | translate"
					[filterEnabled]="false"
					[placeholder]="
						'common_filter_search-placeholder' | translate
					"
					[multiple]="false"
					(change)="handleFormationFilterChange()"
					style="width: 180px"
				></hpf-formation-select>
			</div>
			<!-- /Sort and Filter -->
		</div>
	</div>

	<!-- List -->
	<div *ngIf="searchParams && !loading" class="container-xl ml-0">
		<ng-container *ngIf="thematiques.length > 0; else emptyTpl">
			<ng-container *ngIf="mode === 'inline'">
				<ng-container
					*ngTemplateOutlet="
						contentInline;
						context: { items: thematiques }
					"
				></ng-container>
			</ng-container>

			<ng-container *ngIf="mode === 'card'">
				<ng-container
					*ngTemplateOutlet="
						contentCard;
						context: { items: thematiques }
					"
				></ng-container>
			</ng-container>
		</ng-container>

		<!-- Pagination -->
		<div
			class="col-12 d-flex justify-content-center pagination-container"
			*ngIf="totalItems > limit"
		>
			<nz-pagination
				[nzPageIndex]="currentPageIndex"
				[nzPageSize]="limit"
				[nzTotal]="totalItems"
				(nzPageIndexChange)="handleNextPage($event)"
			></nz-pagination>
		</div>
		<!-- /Pagination -->
	</div>
	<!--/ List -->

	<!-- Loading -->
	<div *ngIf="loading" class="container-xl ml-0">
		<ng-container *ngTemplateOutlet="loadingTpl"></ng-container>
	</div>
	<!-- /Loading -->
</div>

<!-- List Inline Content -->
<ng-template #contentInline let-items="items">
	<div class="col-12 py-3 px-0 list-inline-container">
		<div
			class="row d-flex flex-nowrap justify-content-start align-items-center px-0 pb-3 m-0 mx-md-4 head-list-inline"
		>
			<span class="col-5 col-xl-5 sponsor">{{
				'thematique_formation-list-inline-title-sponsor' | translate
			}}</span>
			<span class="col-2 col-sm-3 col-xl-5 thematique">{{
				'thematique_formation-list-inline-title-name-thematique'
					| translate
			}}</span>
			<span class="col-2 date">{{
				'thematique_formation-list-inline-title-date' | translate
			}}</span>
		</div>

		<ng-container
			*ngFor="let formationThematique of items; trackBy: trackById"
			class="item-list-container"
		>
			<app-atom-formation-thematique-card
				[formationThematique]="formationThematique"
				[inline]="true"
			></app-atom-formation-thematique-card>
		</ng-container>
	</div>
</ng-template>
<!-- /List Inline Content -->

<!-- List Card Content -->
<ng-template #contentCard let-items="items">
	<div class="col-12 py-4 list-card-container">
		<div
			*ngFor="let formationThematique of items; trackBy: trackById"
			class="item-card-container"
		>
			<app-atom-formation-thematique-card
				[formationThematique]="formationThematique"
			></app-atom-formation-thematique-card>
		</div>
	</div>
</ng-template>
<!-- List Card Content -->

<!-- Loading -->
<ng-template #loadingTpl>
	<div class="text-center">
		<app-atom-concept-loader></app-atom-concept-loader>
	</div>
</ng-template>
<!-- /Loading -->

<!-- Empty list -->
<ng-template #emptyTpl>
	<div class="col-12 py-4 card-container empty">
		<p>{{ 'report_moderated-list-empty' | translate }}</p>
	</div>
</ng-template>
<!-- /Empty list -->
